export default class CandidatesCount {
  constructor() {
    this.reservedExchanged = '...'
    this.reserveExchange = '...'
    this.tasks = '...'
    this.wait = '...'
    this.processed = '...'
    this.mijnCbrQueue = '...'
    this.reservedAll = '...'
    this.topCbrQueue = '...'
    this.all = '...'
    this.topСbrExchangeQueue = '...'
    this.topСbrReserveQueue = '...'
    this.allReservedWillCome = '...'
    this.allReservedWillNotCome = '...'
  }

  set(item = {}) {
    this.reservedExchanged = item.reserved_and_exchanged
    this.reserveExchange = item.reserve_and_exchange_queue
    this.tasks = item.task_list
    this.wait = item.wait_list
    this.processed = item.processed
    this.mijnCbrQueue = item.mijn_cbr_queue
    this.reservedAll = item.all_reserved
    this.topCbrQueue = item.top_cbr_queue
    this.all = item.all
    this.topСbrReserveQueue = item.top_cbr_reserve_queue
    this.topСbrExchangeQueue = item.top_cbr_exchange_queue
    this.allReservedWillCome = item.all_reserved_will_come
    this.allReservedWillNotCome = item.all_reserved_will_not_come
  }
}